import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resourcesToBackend from 'i18next-resources-to-backend';

const resources = {
  es: () => import('./locales/es/es.json'),
  en: () => import('./locales/en/en.json'),
  cat: () => import('./locales/cat/cat.json'),
  pt: () => import('./locales/pt/pt.json'),
  fr: () => import('./locales/fr/fr.json'),
  it: () => import('./locales/it/it.json'),
};

const originalInfo = console.info;
console.info = (...args) => {
  if (typeof args[0] === "string" && args[0].includes("locize")) return;
  originalInfo(...args);
};

i18n
  .use(resourcesToBackend((lng: string) => {
    return resources[lng as keyof typeof resources]();
  }))
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['es', 'en', 'cat', 'pt', 'fr', 'it'],
    fallbackLng: "es",
    nonExplicitSupportedLngs: true,
    load: 'currentOnly',
    partialBundledLanguages: true,
    detection: {
      order: ['localStorage', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false
    }
  }).then(() => {
    console.info = originalInfo;
  });

export default i18n;